import { useState } from 'react'
import {
  Info, X, ChevronDown, Search, MapPin, Accessibility, Languages, Lock, User, Sparkles,
} from 'lucide-react'

function InfoFlash({ onClose }) {
  return (
    <div className="cdg-infoflash">
      <div className="cdg-container">
        <div className="cdg-infoflash-msg">
          <Info size={16} />
          <span><strong>Elections professionnelles 2026</strong> — Inscriptions ouvertes jusqu'au 30 avril. <a href="#">En savoir plus</a></span>
        </div>
        <button onClick={onClose} aria-label="Fermer"><X size={16} /></button>
      </div>
    </div>
  )
}

function UtilityBar() {
  return (
    <div className="cdg-utility">
      <div className="cdg-container">
        <a href="#"><MapPin size={12} />Contact &amp; acces</a>
        <span className="sep" />
        <a href="#"><Accessibility size={12} />Accessibilite</a>
        <span className="sep" />
        <a href="#"><Languages size={12} />FR</a>
        <span className="sep" />
        <a href="#"><Lock size={12} />Espace connecte</a>
      </div>
    </div>
  )
}

function NavItem({ label, items }) {
  return (
    <div className="cdg-nav-item">
      <button className="cdg-nav-btn">
        {label}
        {items && <ChevronDown size={12} />}
      </button>
      {items && (
        <div className="cdg-mega-menu">
          {items.map(i => <a key={i} href="#">{i}</a>)}
        </div>
      )}
    </div>
  )
}

export default function Cdg31Header({ onOpenChat }) {
  const [flash, setFlash] = useState(true)

  return (
    <>
      {flash && <InfoFlash onClose={() => setFlash(false)} />}
      <UtilityBar />
      <header className="cdg-header cdg-header-v3">
        <div className="cdg-container cdg-header-main">
          <a href="/cdg31" className="cdg-logo" aria-label="CDG31 — Accueil">
            <img src="/assets/cdg31/logos/CDG31_1_quadri.png" alt="CDG31 · Centre de gestion de la Haute-Garonne" />
          </a>
          <div className="cdg-header-right">
            <button className="cdg-search-pill">
              <Search size={16} /><span>Rechercher sur le site...</span>
              <kbd className="cdg-kbd">Ctrl K</kbd>
            </button>
            <a className="cdg-btn cdg-btn-primary cdg-btn-sm"><User size={14} />Mon espace</a>
          </div>
        </div>
      </header>
      <nav className="cdg-navbar cdg-navbar-v3" aria-label="Navigation principale">
        <div className="cdg-container">
          <div className="cdg-nav">
            <NavItem label="Nos services" items={['Recrutement & emploi', 'Formation professionnelle', 'Sante & prevention', 'Instances paritaires', 'Conseil juridique', 'Mediation']} />
            <NavItem label="Concours & emploi" items={['Calendrier des concours', "Offres d'emploi", 'Mobilite & detachement', 'Integrer la FPT']} />
            <NavItem label="Ressources" items={['Fiches pratiques', 'Modeles de documents', 'Circulaires & textes', 'Simulateurs RH']} />
            <a href="#actualites" className="cdg-nav-link">Actualites</a>
            <a href="#agenda" className="cdg-nav-link">Agenda</a>
            <NavItem label="Le CDG31" items={["Presentation", 'Gouvernance', "Projet d'etablissement", 'Contact']} />
            <div style={{ marginLeft: 'auto' }}>
              <button className="cdg-nav-ai" onClick={onOpenChat}>
                <Sparkles size={15} />
                <span>Assistant&nbsp;IA</span>
                <span className="cdg-nav-ai-badge">Nouveau</span>
              </button>
            </div>
          </div>
        </div>
      </nav>
    </>
  )
}
